// Define the function to extract year and month
export default function extractYearAndMonth(dateString) {
  if (!dateString) {
    return { year: null, month: null };
  }

  const parts = dateString.split('-');
  if (parts.length !== 3) {
    return { year: null, month: null };
  }

  const [year, month, day] = parts;
  const monthNames = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December',
  ];

  const monthIndex = parseInt(month, 10) - 1;
  const monthName = monthNames[monthIndex] || null;

  const today = new Date();
  const todayYear = today.getFullYear().toString();
  const todayMonth = (today.getMonth() + 1).toString().padStart(2, '0');
  const todayDay = today.getDate().toString().padStart(2, '0');

  if (year === todayYear && month === todayMonth && day === todayDay) {
    return { year: ' Today', month: 'Joined' };
  }

  return { year, month: monthName };
}
